var _excluded = ["isOpen", "hideCloseButton", "children", "onClose"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useEffect, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { func, bool, node } from 'prop-types';
import { Close } from '@gympass/yoga-icons';
import { usePortal } from '../../hooks';
import { Button, Card, Box } from '../..';
export var StyledDialog = styled(Card)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"])), function (_ref) {
  var onClose = _ref.onClose,
      dialog = _ref.theme.yoga.components.dialog;
  return "\n  padding: " + (onClose ? dialog.padding.withCloseButton : dialog.padding.top) + "px \n  " + dialog.padding["default"] + "px \n  " + dialog.padding["default"] + "px;\n\n  width: " + dialog.width["default"] + "px;\n  min-height: " + dialog.height.min + "px;\n  border-radius: " + dialog.border.radius + "px;\n  ";
});
var Overlay = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var dialog = _ref2.theme.yoga.components.dialog;
  return "\n  display: flex;\n  z-index: 3;\n  justify-content: center;\n  align-items: center;\n\n  position: fixed;\n  top: " + dialog.position["default"] + ";\n  right: " + dialog.position["default"] + ";\n  left: " + dialog.position["default"] + ";\n  bottom: " + dialog.position["default"] + ";\n\n  background-color: rgba(35, 27, 34, 0.48);\n  ";
});

var Dialog = function Dialog(_ref3) {
  var isOpen = _ref3.isOpen,
      hideCloseButton = _ref3.hideCloseButton,
      children = _ref3.children,
      onClose = _ref3.onClose,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  var dialogRef = useRef(null);
  var dialogElement = usePortal('dialog');
  var isCloseButtonVisible = onClose && !hideCloseButton;
  var closeDialog = useCallback(function (e) {
    if (dialogRef.current === e.target && isOpen && onClose) {
      onClose(e);
    }

    return true;
  }, [onClose]);
  var keyPress = useCallback(function (e) {
    if (e.key === 'Escape' && isOpen && onClose) {
      onClose(e);
    }

    return true;
  }, [onClose]);
  useEffect(function () {
    document.addEventListener('keydown', keyPress);
    return function () {
      return document.removeEventListener('keydown', keyPress);
    };
  }, [keyPress]);
  return isOpen ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Overlay, {
    onClick: closeDialog,
    onClose: onClose,
    ref: dialogRef
  }, /*#__PURE__*/React.createElement(StyledDialog, _extends({
    onClose: onClose
  }, props), isCloseButtonVisible && /*#__PURE__*/React.createElement(Box, {
    d: "flex",
    justifyContent: "flex-end",
    w: "100%"
  }, /*#__PURE__*/React.createElement(Button.Icon, {
    icon: Close,
    inverted: true,
    onClick: onClose
  })), children)), dialogElement) : /*#__PURE__*/React.createElement(React.Fragment, null);
};

Dialog.propTypes = {
  /** Control the dialog visibility. */
  isOpen: bool,

  /** Hide the close button when onClose prop is defined. */
  hideCloseButton: bool,

  /** Function to close the dialog. */
  onClose: func,
  children: node.isRequired
};
Dialog.defaultProps = {
  isOpen: false,
  hideCloseButton: false,
  onClose: undefined
};
Dialog.displayName = 'Dialog';
export default Dialog;